import { roundMoney } from "@/modules/planos/helpers/roundMoney";

/**
 * Mesma conta da API (PlanoPeriodicidade::calcularValores): base x (1 - percentual / 100),
 * arredondada para centavos.
 *
 * @param {{ valuePercent: number, baseValue: number, safeValue: number }} [options={valuePercent = 0, baseValue = 0, safeValue = 0}]
 */
export function calcDesconto(options = {}) {
  const { valuePercent = 0, baseValue = 0, safeValue = 0 } = options;
  const value = Math.max(
    roundMoney(baseValue * (1 - valuePercent / 100)),
    safeValue
  );

  return {
    value,
    discount: roundMoney(baseValue - value),
  };
}
